import { useQuery } from '@tanstack/react-query';
import { invokeEdgeFunction } from '@/lib/edge-functions';
import { getApiSeasonYear } from '@/lib/season';
import { useSeason } from '@/context/SeasonContext';
import { useLeagueConfig } from '@/hooks/useLeagueConfig';

interface CompetitionTeam {
  id: number;
  name: string;
  code: string;
  logo: string;
  founded: number;
  venue: {
    id: number;
    name: string;
    address: string;
    city: string;
    capacity: number;
    surface: string;
    image: string;
  };
}

export const useTeams = (seasonOverride?: string) => {
  const { leagueActiveSeason } = useSeason();
  const season = seasonOverride ?? getApiSeasonYear(leagueActiveSeason);
  const { competitionId, competition } = useLeagueConfig();

  return useQuery({
    queryKey: ['teams', season, competitionId],
    queryFn: async () => {
      console.log(`Fetching ${competition.name} teams for season ${season}`);

      const { data, error } = await invokeEdgeFunction('fetch-teams', {
        body: { season, competitionId }
      });

      if (error) {
        console.error(`Error fetching ${competition.name} teams:`, error);
        throw new Error(error.message);
      }

      return data as { teams: CompetitionTeam[]; season: string; totalTeams: number; competitionId?: number };
    },
    enabled: competitionId != null,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
  });
};
